module.exports = __webpack_public_path__ + "img/icon_qrcode.8b5ee727.png";